import { actionCreator } from '../../../../utils/actions';

export const editVehicleClick = actionCreator('EDIT_VEHICLE_CLICK');
export const editDeviceNameClick = actionCreator('EDIT_DEVICE_NAME_CLICK');
export const editDeviceNameSave = actionCreator('EDIT_DEVICE_NAME_SAVE');



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/VehiclesSettings/actions.js